import { render, staticRenderFns } from "./v-checkbox.vue?vue&type=template&id=662f2ceb&scoped=true&"
import script from "./v-checkbox.vue?vue&type=script&lang=ts&"
export * from "./v-checkbox.vue?vue&type=script&lang=ts&"
import style0 from "./v-checkbox.vue?vue&type=style&index=0&id=662f2ceb&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "662f2ceb",
  null
  
)

export default component.exports